export enum EventNames {
  ADD_PAYMENT_INFO = 'add_payment_info',
  ADD_TO_CART = 'add_to_cart',
  BEGIN_CHECKOUT = 'begin_checkout',
  GENERATE_LEAD = 'generate_lead',
  PAGE_VIEW = 'page_view',
  PURCHASE = 'purchase',
  SCHEDULE_ITEM = 'schedule_item',
  SCREEN_VIEW = 'screen_view',
  SELECT_ITEM = 'select_item',
  SIGN_UP = 'sign_up',
  TRACK_CONFIRM_AGE = 'track_confirm_age',
  TRACK_PAY_METHOD = 'track_pay_method',
  TRACK_SIGN = 'track_sign',
  TRACK_WARNING = 'track_warning',
  TUTORIAL_BEGIN = 'tutorial_begin',
  TUTORIAL_COMPLETE = 'tutorial_complete',
}
